import React, { memo } from 'react'
import { useRating, RatingProps } from './useRating'
import Star from './Star/Star'
import styles from './Rating.module.scss'

const Rating: React.FC<RatingProps> = (props: RatingProps) => {
  const { stars, rate, handleChange } = useRating(props)

  return (
    <div className={styles.rating}>
      {stars.map((star) => (
        <Star key={star} star={star} rate={rate} handleChange={handleChange} />
      ))}
    </div>
  )
}

export default memo(Rating)
